import { createContext, useContext } from "react";

export interface AssistantApi {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

/** Default is a no-op so pages render outside the shell (tests, demos). */
export const AssistantContext = createContext<AssistantApi>({
  isOpen: false,
  open: () => {},
  close: () => {},
});

export function useAssistant(): AssistantApi {
  return useContext(AssistantContext);
}
